module.exports = __webpack_public_path__ + "static/img/chargenow.efc32f2b.png";